import router from '@/router'
import WechatAuth from '@/libs/wechat-auth'
import { loginWechat, getProfile } from "@/api/user"; //  getProfile, 
import {
  setToken,
  getToken,
  setWXInfo,
  setUserInfo,
} from '@/libs/cookie-storage'
import { UrlUtil, isWeChatMiniApp } from '@/utils'
import { AppType } from '@/constants/appType'
import { ConstConfig } from '@/constants'
import url from 'url'
import querystring from 'querystring'
import wx from 'weixin-js-sdk'
import { buildFullHashRedirectUrl } from '@/utils/redirect'

const wechatAuth = new WechatAuth({
  appid: ConstConfig.wxAppId // 微信appid
})

// 需要有passport和绑定手机
// token->mobile->pass 流程
function checkAuthValid() {
  const passport = getToken()
  const query = UrlUtil.getHashQueryParams()
  if (query && query.passport) {
    setToken(query.passport)
  }
  if (passport || (query && query.passport)) {
    // 检查手机绑定
    // const bindMobile = getBindMobile()
    // if (bindMobile === 'true') {
    //   return 'pass'
    // } else {
    //   return 'mobile'
    // }
    return 'pass'
  } else {
    return 'token'
  }
}

function getPassportByWeChat(authCode) {
  return new Promise((resolve, reject) => {
    loginWechat(authCode)
      .then(async response => {
        // alert(JSON.stringify(response))
        const data = response.data
        if (data.openId) {
          setWXInfo({
            openId: data.openId
          })
        }
        if (data.passport) {
          setToken(data.passport)
          const res = await getProfile({ passport: data.passport })
          const user = res.data.user
          if (user) {
            setUserInfo(user)
            const logins = user.logins || []
            const noBindMobile = logins.every(item => item.type !== 'mobile')
            if (noBindMobile) { // 未绑定手机号
              const redirect = window.sessionStorage.getItem('redirect_path')
              router.replace({ name: 'AuthLogin', query: { redirect: encodeURIComponent(redirect) } })
              return
            }
          }
        } else {
          const redirect = window.sessionStorage.getItem('redirect_path')
          router.replace({ name: 'AuthLogin', query: { redirect: encodeURIComponent(redirect) } })
          return
        }
        wechatAuth.removeUrlCodeQuery()
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function authHandleInWeChat(redirectUri) {
  const query = querystring.parse(url.parse(window.location.href).query)
  let code = query.code
  if (Array.isArray(code)) {
    code = code[code.length - 1]
  }
  const authCode = wechatAuth.getAuthCode()
  if (code && !authCode) {
    wechatAuth.setAuthCode(code)
    return new Promise((resolve, reject) => {
      getPassportByWeChat(code)
        .then(response => {
          if (response.passport) {
            // wechatAuth.removeUrlCodeQuery()
            resolve(true)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  } else {
    window.sessionStorage.setItem('redirect_path', redirectUri)
    wechatAuth.openAuthPage()
  }
}

function handleAuthPage(redirect, isNotAuthPage) {
  if (!isNotAuthPage) {
    router.replace({ name: 'AuthLogin', query: { redirect: encodeURIComponent(redirect) } })
  }
}

export function getPassport(isNotAuthPage) {
  return new Promise((resolve) => {
    const authState = checkAuthValid()
    let redirect = window.location.hash
    redirect = redirect.substring(1) // 获取重定向页面
    if (authState === 'pass') {
      wechatAuth.removeAuthCode()
      resolve(true)
    } else if (authState === 'mobile') {
      handleAuthPage(redirect, isNotAuthPage)
    } else {
      if (AppType.isInApp()) {
        handleAuthPage(redirect, isNotAuthPage)
      } else if (AppType.isInWeChat()) { // 微信环境
        isWeChatMiniApp().then(res => {
          if (res) { // 微信小程序
            const fullRedirectUrl = buildFullHashRedirectUrl()
            const url = '/pages/common/login?redirect=' + encodeURIComponent(fullRedirectUrl)
            wx.miniProgram.navigateTo({ url })
          } else {
            authHandleInWeChat(redirect, isNotAuthPage).then(res => {
              if (res) {
                resolve(res)
              }
            })
          }
        })
      } else {
        handleAuthPage(redirect, isNotAuthPage)
      }
    }
  })
}
